import { Injectable } from '@angular/core';
import { API_TOKEN } from 'src/app/core/utils/Constants';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    isLoggedIn = false;

    constructor(
        
    ) {
        if(API_TOKEN === undefined || API_TOKEN === null || API_TOKEN === '') {
            this.isLoggedIn = false;
        } else {
            this.isLoggedIn = true;
        }
    }

    login() {
        this.isLoggedIn = true;
    }

    logout() {
        localStorage.clear();
        this.isLoggedIn = false;
    }

}

